var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"brazil-card",class:{ active: _vm.active, 'reg-outlined': _vm.regOutlined},attrs:{"outlined":_vm.outlined,"raised":_vm.raised,"flat":_vm.flat}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }